import 'react-loading-skeleton/dist/skeleton.css';

import { Button, Card, Input } from '@nextui-org/react';
import latinize from 'latinize';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Search as SearchIcon } from 'react-feather';
import Typesense from 'typesense';

import { isDarkMode, normalizeArabic, splitStringWithTags } from '../utils/utils';
import AnimateHeight from './AnimateHeight';
import Delay from './Delay';
import PopIn from './PopIn';

const tsClient = new Typesense.Client({
  nodes: [
    {
      host: 'api.thaqalayn.net',
      port: 8109,
      protocol: 'https',
    },
  ],
  // this is the public api key - okay to expose
  apiKey: '28hiWOETpty6j8gtJZtXv3A1FUQq3Unr',
});

const SearchResultsNew = ({ hadithResults, searchResults, searchTerm }: any) => {
  const activeSearch = (
    <AnimateHeight className="search-card4 !box-border !p-0" duration={0.3} initial={true} open={true}>
      {searchTerm ? (
        hadithResults.slice(0, 8).map(({ document, highlight, highlights }: any, i: number) => (
          <Link
            key={document.id}
            className="!p-0 !box-border"
            href={`/hadith/${document?.book_id}/${document?.book_section_number}/${document?.chapter_number}/${document?.hadith_number}`}
            scroll={false}
          >
            <PopIn className="!p-0 !box-border !h-max" duration={0.1 + i / 10} initial={true} loaded={true}>
              <div
                key={document.id}
                className={`w-full !h-max py-2 mt-2 !box-border ${
                  isDarkMode() ? 'hover:bg-blue-400 hover:text-slate-100' : 'hover:bg-blue-100 hover:text-slate-600'
                }
             ease-in-out`}
                onClick={(e) => e.stopPropagation()}
              >
                {splitStringWithTags(highlights[0]?.snippet).map((part) => {
                  if (part.startsWith('<mark>'))
                    return (
                      <span
                        key={part}
                        className={`!p-0 font-bold  ${isDarkMode() ? 'text-yellow-400 ' : 'text-blue-600'}`}
                      >
                        {part.replace('<mark>', '').replace('</mark>', '')}
                      </span>
                    );
                  else return part;
                })}
              </div>
            </PopIn>
          </Link>
        ))
      ) : (
        <div></div>
      )}
    </AnimateHeight>
  );

  return (
    <>
      <li className="box-content"></li>
      {activeSearch}
    </>
  );
};

export function DropdownSearch() {
  const [searchResults, setSearchResults] = useState<any>([]);
  const [hadithResults, setHadithResults] = useState<any>([]);
  const [searchedText, setSearchedText] = useState<string>('');
  const [searchFocus, setSearchFocus] = useState<boolean>(false);
  const [searchDebounce, setSearchDebounce] = useState<any>(null);

  const router = useRouter();

  const searchHandler = async (e: any) => {
    if (searchDebounce) clearTimeout(searchDebounce);
    setSearchedText(e.target.value);

    setSearchDebounce(
      setTimeout(() => {
        let searchParameters = {
          q: e.target.value,
          query_by: 'name',
          infix: 'always',
        };

        // tsClient
        //   .collections('books')
        //   .documents()
        //   .search(searchParameters)
        //   .then((response: any) => {
        //     setSearchResults(response.hits);
        //   });

        tsClient
          .collections('hadiths')
          .documents()
          .search({
            q: latinize(normalizeArabic(e.target.value)),
            query_by: 'content',
            // infix: 'always',
            // highlight_fields: 'content',
            filter_by: 'language:[EN,AR]',
            snippet_threshold: 75,
          })
          .then((response: any) => {
            setHadithResults(response.hits);
            // console.log(response.hits);
          });
      }, 300)
    );
  };

  return (
    <div>
      <Input
        clearable
        aria-label="Search for books, hadiths, etc."
        contentLeft={<SearchIcon size={16} />}
        contentLeftStyling={false}
        contextMenu=""
        placeholder="Search..."
        css={{
          w: '100%',
          '@xsMax': {
            w: '300px',
            jc: 'center',
          },
          '& .nextui-input-content--left': {
            h: '100%',
            ml: '$2',
            dflex: 'center',
          },
        }}
        onChange={searchHandler}
        onFocus={() => setSearchFocus(true)}
        onBlurCapture={() => {
          setTimeout(() => {
            setSearchFocus(false);
          }, 200);
        }}
        onClearClick={() => {
          setSearchedText('');
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            router.push(`/search?q=${searchedText}`);
          }
        }}
      />
      {/* <Accordion
        duration={0.2}
        open={!!(searchFocus && searchedText) || true}
        className="absolute bottom--14 w-96 -left-1 mt-2"
      > */}
      {searchFocus && searchedText && searchedText.trim() != '' && (
        <Delay waitBeforeShow={100}>
          <Card
            className="absolute bottom--14 w-96 -left-1 mt-2 !box-content"
            id="search-card3"
            onClick={() => setSearchFocus(true)}
          >
            <Card.Header className="w-full m-auto !box-border">
              <span className="text-center font-bold !box-content">Search Results</span>
            </Card.Header>
            <SearchResultsNew hadithResults={hadithResults} searchResults={searchResults} searchTerm={searchedText} />
            <Card.Footer>
              <div className="!box-border">
                <Button
                  flat
                  className="!box-border"
                  onClick={() => {
                    router.push(`/search${searchedText && '?q=' + searchedText}`);
                  }}
                >
                  Advanced Search →
                </Button>
              </div>
            </Card.Footer>
          </Card>
        </Delay>
      )}
      {/* </Accordion> */}
    </div>
  );
}
